import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { MaterialModule } from '../material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { RouterModule } from '@angular/router';
import { PillarModule } from '../pillar/pillar.module'
import { messagesRoutes } from './routes.config';
import { ModuleConfiguration } from './messages.module.config';
import { reducers } from './store/reducers';
import { MessagesServiceEffects } from "./services/MessagesService.effects";
import { MessagesService } from './services/MessagesService';
import { AdministrationDashboardComponent } from '../administration/components/administration-dashboard.component';
import { DashboardTilesRegistry } from '../pillar/dashboard/services/DashboardTilesRegistry';
import { MessagesTileComponent } from './components/messages-tile.component';
import { MessagesWorkspaceComponent } from './components/messages-workspace.component';
import { CoreModule } from '../core/core.module';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule, MatNativeDateModule } from '@angular/material';
import { QuillModule } from 'ngx-quill'

@NgModule({
  entryComponents: [MessagesTileComponent],
  declarations: [MessagesTileComponent, MessagesWorkspaceComponent],
  imports: [
    CommonModule,
    MaterialModule,
    FlexLayoutModule,
    StoreModule.forFeature(ModuleConfiguration.moduleName, reducers),
    EffectsModule.forFeature([MessagesServiceEffects]),
    RouterModule.forChild(messagesRoutes),
    PillarModule,
    ReactiveFormsModule,
    CoreModule,
    MatDatepickerModule,
    MatNativeDateModule,
    QuillModule
  ],
  exports: [],
  providers: [MessagesService, MatDatepickerModule]
})
export class MessagesModule {
  constructor(private dashboardTilesRegistry: DashboardTilesRegistry) {
    dashboardTilesRegistry.registerTile(AdministrationDashboardComponent.dashboardName,
      {
        position: {
          colSpan: 4,
          rowSpan: 1.5
        },
        priorityOrder: 0,
        tileComponent: MessagesTileComponent,
        permission: "ConfigurationModule.Messages:View",
        displayName: "Message"
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/messages/messages.module.ts